// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V-Lw","placeholdersHeader":"styles_placeholdersHeader__3DbRg","editorStyle":"styles_editorStyle__2Ba9d","placeholdersBox":"styles_placeholdersBox__Y9eJO"};